import * as profileActions from '../actions/occupationProfile'
import * as h2Api from '../h2Api'

const initialState = {
  regions: [],
  defaultRegion: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.LOAD_COMPARISON_REGIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          regions: action.restCall.result.regions,
          defaultRegion: action.restCall.result.defaultRegion
        }
      }

      return state

    default:
      return state
  }
}

export default reducers
